module.exports = __webpack_public_path__ + "img/wordpress.46d2c1fd.svg";